import { gql } from "gql";

export const GET_READ_UNREAD_PERSONS = gql(/* GraphQL */ `
  query GetReadUnreadPersons(
    $id: ID!
    $filter: PersonConfirmationFilter
    $pageRequest: PageRequest
  ) {
    getCompanyDocumentById(id: $id) {
      ...CompanyDocumentReadConfirmationType

      personsConfirmationInfo(filter: $filter, pageRequest: $pageRequest) {
        total
        content {
          ...CompanyDocumentAnalyticsRecord
        }
      }

      confirmationInfoCount {
        ...CompanyDocumentConfirmationInfoCountReadStat
        ...CompanyDocumentConfirmationInfoCountUnreadStat
      }
    }
  }
`);
